import classNames from 'classnames'
import Icon from './Icon'

interface Props {
  className?: string
  size?: number
  isVisible?: boolean
  title?: string
}

export default function Loading({ className, size, isVisible = true, title = 'loading' }: Props) {
  if (!isVisible) {
    return null
  }

  return (
    <div className={classNames('Loading', className)}>
      <Icon className="Loading__indicator" name="Loader" size={size} title={title} />
    </div>
  )
}
